module.exports = __webpack_public_path__ + "static/media/script.a1c946f8.svg";